@if (isLoggedIn && hasPersonalContent && isPersonalContentEnabled && enabled) {
  <button
    (click)="action.emit()"
    id="all_toolbar_btn_open-help"
    mat-icon-button
    title="Co-op messages"
    >
    <mat-icon class="fill">mail</mat-icon>
  </button>
}
